// client/src/utils/marketerResultCache.js

const CACHE_PREFIX = 'MARKETER_RESULT_';
const CACHE_TTL = 5 * 60 * 1000; // 5분

// sessionStorage 헬퍼
const ss = typeof window !== 'undefined' ? window.sessionStorage : null;

function cacheSet(key, value) {
  if (!ss) return;
  try {
    ss.setItem(key, JSON.stringify({
      data: value,
      timestamp: Date.now(),
      uid: window.__ME__?.id  // ✅ 사용자 ID 함께 저장
    }));
  } catch (e) {
    console.error('결과물 캐시 저장 실패:', e);
  }
}

function cacheGet(key) {
  if (!ss) return null;
  try {
    const cached = ss.getItem(key);
    if (!cached) return null;
    
    const { data, timestamp, uid } = JSON.parse(cached);
    
    // ✅ TTL 체크
    if (Date.now() - timestamp > CACHE_TTL) {
      ss.removeItem(key);
      return null;
    }
    
    // ✅ 사용자 검증
    const currentUid = window.__ME__?.id;
    
    // currentUid가 없으면 null 반환
    if (!currentUid) {
      return null;
    }
    
    // currentUid가 있는데 캐시 uid와 다르면 삭제
    if (uid && uid !== currentUid) {
      console.warn('결과물 캐시 사용자 불일치, 삭제:', key);
      ss.removeItem(key);
      return null;
    }
    
    return data;
  } catch (e) {
    console.error('결과물 캐시 조회 실패:', e);
    return null;
  }
}

// 프로젝트 목록 캐시
export function cacheResultProjectList(uid, projects) {
  cacheSet(`${CACHE_PREFIX}LIST:${uid}`, projects);
}

export function readResultProjectList(uid) {
  return cacheGet(`${CACHE_PREFIX}LIST:${uid}`);
}

// 결과물 목록 캐시 (필터 포함)
export function cacheResults(projectId, results, filter = 'all') {
  cacheSet(`${CACHE_PREFIX}RES:${projectId}:${filter}`, results);
}

export function readResults(projectId, filter = 'all') {
  return cacheGet(`${CACHE_PREFIX}RES:${projectId}:${filter}`);
}

// 캐시 초기화
export function clearResultCache(uid) {
  if (!ss) return;
  try {
    const keys = Object.keys(ss);
    keys.forEach(key => {
      if (key.startsWith(CACHE_PREFIX)) {
        ss.removeItem(key);
      }
    });
  } catch (e) {
    console.error('결과물 캐시 초기화 실패:', e);
  }
}

// 백그라운드 로드
export async function warmResultProjects(uid) {
  if (!uid) return;
  
  try {
    // 1. 프로젝트 목록 조회
    const res = await fetch('/api/marketer/projects/with-results', {
      credentials: 'include'
    });
    const data = await res.json();
    
    if (res.ok && data.ok && data.projects) {
      cacheResultProjectList(uid, data.projects);
      
      // 2. 첫 번째 프로젝트의 결과물 목록 조회 (즉시 실행)
      if (data.projects.length > 0) {
        const firstProjectId = data.projects[0].id;
        
        try {
          // filter=all 캐싱
          const resAll = await fetch(
            `/api/marketer/projects/${firstProjectId}/results?filter=all`,
            { credentials: 'include' }
          );
          const dataAll = await resAll.json();
          
          if (resAll.ok && dataAll.ok) {
            cacheResults(firstProjectId, dataAll.results, 'all');
          }

          // filter=pending 캐싱 (백그라운드)
          const resPending = await fetch(
            `/api/marketer/projects/${firstProjectId}/results?filter=pending`,
            { credentials: 'include' }
          );
          const dataPending = await resPending.json();
          
          if (resPending.ok && dataPending.ok) {
            cacheResults(firstProjectId, dataPending.results, 'pending');
          }
        } catch (e) {
          console.error('결과물 목록 백그라운드 로드 실패:', e);
        }
      }
    }
  } catch (e) {
    console.error('결과물 프로젝트 목록 백그라운드 로드 실패:', e);
  }
}

